// Configurações do checkout da Shopify
(function () {
  'use strict';

  // Abre o modal para cadastro ou edição do domínio
  const $modal = $('#modal-dominio');
  const $modalTitle = $modal.find('.modal-title');
  const $modalBtn = $modal.find('.btn-submit');
  $('.btn-toggle-domain-checkout').on('click', function (ev) {
    ev.preventDefault();
    const acao = $(this).data('action');
    console.log(acao);
    $modalTitle.text($modalTitle.data(acao));
    $modalBtn.text($modalBtn.data(acao));
    if (acao == 'insert') {
      $modal.find('input[name="acao"]').val('insert_domain');
    } else if (acao == 'update') {
      $modal.find('input[name="acao"]').val('update_domain');
    }
    $('#modal-dominio').modal('show');
  });

  // Ao digitar o domínio, evita que seja digitado o subdomínio do checkout
  const $campoDominio = $('#dom_checkout_cad');
  $campoDominio.on('input', function () {
    const $ele = $(this);
    const domStr = $ele.val();
    $ele.val(domStr.replace('pagamento.', ''));
    handlePreviewDomCheckout();
  });
  // Preview do endereço
  function handlePreviewDomCheckout() {
    const domStr = $campoDominio.val();
    if (domStr != '') {
      $('.lp-url-preview-checkout-wrp').show();
      $('.lp-url-preview-domain-checkout').text(domStr);
    } else {
      $('.lp-url-preview-checkout-wrp').hide();
      $('.lp-url-preview-domain-checkout').text('');
    }
  }
  if ($campoDominio.length > 0) {
    handlePreviewDomCheckout();
  }
})();
